// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2uMr7","col":"styles_col__QX6uw"};